import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { useConversation, useSessionUser } from "@web-app/api";
import { LoadingIcon } from "@web-app/components";

import { useInitiateCall } from "../api/hooks/useLiveKit";
import VoiceCallPopup from "../pages/chatPage/VoiceCallPopup";

export const Route = createFileRoute("/call/$conversationId")({
  component: VoiceCallPage,
});

function VoiceCallPage() {
  const { conversationId } = Route.useParams();
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const initiateCallMutation = useInitiateCall();
  const { data: conversation, isLoading: isLoadingConversation } =
    useConversation(conversationId);
  const { data: currentUser } = useSessionUser();

  useEffect(() => {
    const joinCall = async () => {
      try {
        const tokenData = await initiateCallMutation.mutateAsync({
          conversationId,
        });
        setToken(tokenData.token);
      } catch {
        setError("Failed to join call");
      }
    };

    joinCall();
  }, [conversationId]);

  if (error) {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-gray-50">
        <p className="text-red-500 mb-4">{error}</p>
        <button
          onClick={() => window.close()}
          className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700"
        >
          Close Window
        </button>
      </div>
    );
  }

  if (!token || isLoadingConversation || !conversation || !currentUser) {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-gray-50">
        <LoadingIcon className="w-8 h-8 mb-4" />
        <p className="text-gray-600">Connecting to call...</p>
      </div>
    );
  }

  const driverParticipant = conversation.participantsWithDetails.find(
    (p) => p.role === "DRIVER",
  );
  const otherParticipants = conversation.participantsWithDetails.filter(
    (p) => p.userId !== currentUser.id,
  );
  const headerParticipant = driverParticipant || otherParticipants[0];

  return (
    <VoiceCallPopup
      token={token}
      headerName={headerParticipant?.name || "Unknown"}
      headerImage={headerParticipant?.image}
      orderDisplayId={conversation.orderDisplayId}
    />
  );
}
